module.exports = __webpack_public_path__ + "static/media/post-img9.d027f163.jpg";